import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { stockQuantityService } from 'features/inventory/stock/api/stock-quantity.service';
import { StockQuantitiesColumns } from 'features/inventory/stock/stock-quantities';
import { IsSuperAdminGuard } from 'shared/permissions/IsSuperAdmin';
import { useMemo } from 'react';

interface StockTabProps {
  warehouseId: number;
}

export function StockTab({ warehouseId }: StockTabProps) {
  const isAdmin = IsSuperAdminGuard();
  const columns: GridColDef[] = StockQuantitiesColumns(isAdmin);

  const totalsOuterParams = useMemo(() => {
    return !isAdmin
      ? {
          quantity__gt: '0',
          warehouse__id: `${warehouseId}`
        }
      : { warehouse__id: `${warehouseId}` };
  }, []);

  return (
    <EnhancedDataGrid
      service={stockQuantityService}
      getMethod={stockQuantityService.getStockQuantityWithLocation}
      columns={columns}
      outerParams={totalsOuterParams}
      disableDelete
    />
  );
}
